import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './components/HomePage';
import About from './components/About';

// SEO Head component for dynamic meta tags
const SEOHead = ({ title, description, keywords, canonicalUrl }) => {
  useEffect(() => {
    // Update document title
    document.title = title;
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', description);
    }
    
    // Update meta keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', keywords);
    }
    
    // Update canonical URL
    const canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      canonicalLink.setAttribute('href', canonicalUrl);
    }
  }, [title, description, keywords, canonicalUrl]);
  
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={
          <>
            <SEOHead 
              title="Sabtian Portfolio - Business Analyst Resume"
              description="Sabtian Adiansyah - Business Analyst with 5+ years of experience in data analysis, dashboard automation, and operational optimization."
              keywords="Sabtian, portfolio, resume, ask, Sabtian Adiansyah, Business Analyst, Business System Analyst, Data Analyst"
              canonicalUrl="https://sabtian.my.id"
            />
            <HomePage />
          </>
        } />
        <Route path="/about" element={
          <>
            <SEOHead 
              title="Sabtian Portfolio - Business Analyst Resume"
              description="Sabtian Adiansyah - Business Analyst with 5+ years of experience in data analysis, dashboard automation, and operational optimization."
              keywords="About Sabtian, Sabtian, portfolio, resume, ask, Sabtian Adiansyah, Business Analyst, Business System Analyst, Data Analyst"
              canonicalUrl="https://sabtian.my.id/about"
            />
            <About />
          </>
        } />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
